import { formatNumber } from "./formatNumber";

export const formatCurrency = (amount) => {
  return `R${formatNumber(amount)}`;
};